/**
 * Helper pur — `extractions.error_code` → clé i18n.
 *
 * Remplace `extractionErrorMessage.ts` (9.M.2), qui appliquait des **patterns
 * regex défensifs** sur `error_message` et **retombait sur la chaîne brute** en
 * dernier recours. Cette chaîne provenait de `err.message` côté backend : elle
 * pouvait contenir le message du fournisseur d'IA (« Your credit balance is too
 * low… »), une trace technique, ou un fragment du document client.
 *
 * Contrat 9.W.2 :
 *   - la seule surface affichable d'un échec est `error_code`, un code d'une
 *     énumération FERMÉE définie dans `apps/shared`
 *     (`ExtractionErrorCodeSchema`) ;
 *   - aucune interprétation par regex ni `includes()` ;
 *   - aucun repli sur `error_message`, jamais ;
 *   - un code inconnu — ligne écrite par une version antérieure, ou code ajouté
 *     côté backend avant le déploiement du frontend — rend un libellé
 *     **générique**, pas la valeur brute.
 *
 * Module **pur** (zéro dépendance React/API) — testable en `environment: node`.
 */

import { ALL_EXTRACTION_ERROR_CODES } from "@kollectivia/shared";

const I18N_PREFIX = "submissions.detail.extraction.error_codes";

/** Libellé neutre pour tout code hors énumération connue. */
export const EXTRACTION_ERROR_FALLBACK_KEY = `${I18N_PREFIX}.unknown`;

const KNOWN = new Set<string>(ALL_EXTRACTION_ERROR_CODES);

/**
 * Retourne la clé i18n à passer à `t()` pour un `error_code` donné.
 *
 * @param code valeur brute de `extractions.error_code` (peut être inconnue)
 */
export function extractionErrorCodeKey(code: string): string {
  return KNOWN.has(code) ? `${I18N_PREFIX}.${code}` : EXTRACTION_ERROR_FALLBACK_KEY;
}

/** Vrai si le code appartient à l'énumération partagée courante. */
export function isKnownExtractionErrorCode(code: string): boolean {
  return KNOWN.has(code);
}
